import React from 'react'
import styled, { css } from 'styled-components'
import { above } from '@styles/mixins/breakpoints'

import Arrow from '@icons/stepArrow.inline.svg'
import Box from '@components/Box'
import { STypographyParagraph, STypographyDefault } from '@components/Typography'

export interface IStep {
  heading: string
  text: string
}

export interface ISteps {
  steps: IStep[]
  color?: string
}

export const SStep = styled.div`
  flex-shrink: 0;
  flex-grow: 0;
  height: 100%;
`

const SSteps = styled.div`
  display: flex;
  justify-content: space-between;
  overflow: auto;
  width: calc(100% + 20px);
  scrollbar-width: none;
  -ms-overflow-style: none;
  scrollbar-color: transparent;

  &::-webkit-scrollbar,
  &::-moz-scrollbar {
    width: 0 !important;
    height: 0 !important;
    display: none !important;
    -webkit-appearance: none;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb,
  &::-webkit-scrollbar-track,
  &::-webkit-scrollbar-track-piece,
  &::-webkit-resizer {
    background-color: transparent;
    width: 0 !important;
    height: 0 !important;
  }

  ${above('md')(css`
    width: auto;
    overflow: visible;
  `)}
  ${SStep} {
    width: 216px;
    margin-right: 20px;
    &:first-child {
      width: 216px;
    }
    &:last-child {
      width: 216px;
      margin-right: 0;
    }
    ${above('xl')(css`
      width: 266px;
      margin-right: 40px;
      &:first-child {
        width: 282px;
      }
      &:last-child {
        width: 235px;
        margin-right: 0;
      }
    `)}
  }
`

interface IColor {
  color?: string
}

export const SNumber = styled.div<IColor>`
  font-size: 90px;
  line-height: 90px;
  width: 52px;
  margin-right: 40px;
  color: ${({ theme, color }) => color || theme.colors.green};
  font-family: ${({ theme }) => theme.typography.defaultFontFamily};
  ${above('xl')(css`
    margin-right: 40px;
  `)}
`

const Steps: React.FC<ISteps> = ({ steps, color }) => {
  return (
    <SSteps>
      {steps.map(({ heading, text }, i) => (
        <SStep key={i}>
          <Box display="flex" alignItems="center" mb="12px">
            <SNumber color={color}>{i + 1}</SNumber>
            {i !== steps.length - 1 && <Arrow />}
          </Box>
          <STypographyParagraph
            fontSize="16px"
            lineHeight="24px"
            mb="8px"
            fontWeight="600"
            dangerouslySetInnerHTML={{ __html: heading }}
          />
          <STypographyDefault dangerouslySetInnerHTML={{ __html: text }} />
        </SStep>
      ))}
    </SSteps>
  )
}

export default Steps
